// extracted by mini-css-extract-plugin
export default {"GroupsList":"Groups_GroupsList__yOPvZ","GroupsHeader":"Groups_GroupsHeader__iE0iV","GroupsTitle":"Groups_GroupsTitle__VcGcE","GroupsFooter":"Groups_GroupsFooter__Nkd5E"};